import { render, staticRenderFns } from "./SocialMediaPanel.vue?vue&type=template&id=75b580d4&"
import script from "./SocialMediaPanel.vue?vue&type=script&lang=ts&"
export * from "./SocialMediaPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports